import { useLang } from '@/i18n';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useRouter } from 'next/router';

const F: React.FC = () => {
    const { t } = useLang('dpux');
    const refVideo = useRef<HTMLVideoElement>(null);
    const sources = ['https://websiteoss.ecoflow.com/upload/video/1760162856430/F.mp4', 'https://websiteoss.ecoflow.com/upload/video/1760163169500/F_M.mp4'];
    const posters = ['https://websiteoss.ecoflow.com/upload/image/1760170053616/f-pc.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760170012180/f-m.jpg'];
    const [video, setVideo] = useState('');
    const [poster, setPoster] = useState('');
    const [textEnter, setTextEnter] = useState(false);
    const { locale = '' } = useRouter();
    const handleEnded = () => {
        setTextEnter(true);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneFArr: any[] = [];
            sceneFArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-C',
                    triggerHook: 1,
                    onEnter: () => {
                        setVideo(window.innerWidth >= 1024 ? sources[0] : sources[1]);
                        setPoster(window.innerWidth >= 1024 ? posters[0] : posters[1]);
                    },
                }),
            );
            sceneFArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-F',
                    triggerHook: 1,
                    offset: '50%',
                    duration: '150%',
                    onEnter: () => {
                        if (refVideo?.current) {
                            refVideo.current.currentTime = 0;
                            refVideo.current?.play();
                            setTextEnter(false);
                        }
                    },
                }),
            );
            return () => {
                sceneFArr.forEach((item) => item.destroy());
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-F GtmModuleData-section`}
            id="delta-pro-ultra-x-F"
            data-section-id={'delta-pro-ultra-x-F'}
            data-section-title={t('F_title')}
        >
            <div className="sticky">
                {video && (
                    <>
                        <video
                            src={video}
                            ref={refVideo}
                            className="video"
                            muted
                            playsInline
                            preload="metedate"
                            width="100%"
                            height="100%"
                            onEnded={handleEnded}
                            poster={poster}
                        ></video>
                        <ul className={`items${textEnter ? ' enter' : ''}`}>
                            {[1, 2, 3, 4].map((item) => (
                                <li className="item" key={item}>
                                    <div className="item-name">
                                        {t.rich(`F_item${item}_name`, {
                                            s: (v: string) => <span className="s">{v}</span>,
                                        })}
                                    </div>
                                    <p className="item-line"></p>
                                    <div className="item-text">{t(`F_item${item}_text`)}</div>
                                </li>
                            ))}
                        </ul>
                        {locale === 'ca' && (
                            <div className={`footer ${textEnter ? 'enter' : ''}`}>
                                <p>{t('item_Remarks2')}</p>
                            </div>
                        )}
                    </>
                )}
            </div>
        </section>
    );
};

export default F;
